export const TRANSACTIONS_FETCH = "TRANSACTIONS_FETCH";
export const TRANSACTIONS_RESOLVE = "TRANSACTIONS_RESOLVE";
export const TRANSACTIONS_NO_RESOLVE = "TRANSACTIONS_NO_RESOLVE";
export const TRANSACTIONS_REJECT = "TRANSACTIONS_REJECT";
export const TRANSACTIONS_CANCEL = "TRANSACTIONS_CANCEL";
